import type { ProgressBucket } from '../types'

const SHORT_MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

const CALENDAR_DATE = /^\d{4}-\d{2}-\d{2}$/

// period_start is a calendar date (YYYY-MM-DD): split it, never parse to an instant.
// Day and week periods read as their (first) day, months as MMM 'YY. Anything
// else (an empty stand-in week) has no label.
export const formatPeriodLabel = (
  periodStart: string,
  bucket: ProgressBucket
): string => {
  if (!CALENDAR_DATE.test(periodStart)) {
    return ''
  }
  const [year, month, day] = periodStart.split('-').map(Number)
  const monthName = SHORT_MONTHS[month - 1] ?? ''
  if (bucket === 'month') {
    return `${monthName} '${String(year % 100).padStart(2, '0')}`
  }
  return `${monthName} ${day}`
}
